import breadcrumbsAfterEach from '@/utils/afterEach/breadcrumbs'
import triggerGaPageViewEvent from '@/utils/afterEach/trigger-ga-page-view-event'
import setPageNavigationEnd from '@/utils/afterEach/set-page-navigation-end'

export default function({ app, store }) {
  app.router.afterEach((to, from) => {
    breadcrumbsAfterEach({ app, store, to, from })
    triggerGaPageViewEvent({ app, store, to, from })
    setPageNavigationEnd({ store })
  })
}
